import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
import { actions, getters } from './modules/root';
Vue.use(Vuex);
export default new Vuex.Store({
    modules,
    actions,
    getters,
    strict: process.env.NODE_ENV === 'development',
});
